// utils/recordAttachmentExport.js
// Records a filing attachment as exported, right after a file download has
// already succeeded. Lifted out of VATRecordsList so the DAT/SLSP exporters
// spread across several components share one implementation instead of five
// divergent copies.
//
// `formCode` is a parameter, not a constant: the SLSP flow this started as was
// 2550Q-only, but SAWT also attaches to 2551Q.
import returnFilingAPI from '../api/returnFilingAPI';

// ReturnFiling.attachments[].type is a free-form String with no enum, and the
// mark-exported route takes it as an unvalidated path param — a typo would
// silently create an orphan attachment row that never unblocks filing. These
// constants are the only guard against that; always key off them.
export const ATTACHMENT_TYPES = {
  SLSP_INPUT: 'SLSP_INPUT',
  SLSP_OUTPUT: 'SLSP_OUTPUT',
  SAWT: 'SAWT',
};

export const recordAttachmentExport = async ({
  clientId,
  formCode,
  fiscalYear,
  quarter,
  type,
  total,
}) => {
  // Attachment tracking only makes sense when the export is scoped to one
  // specific quarter — an "All Periods" export spans multiple periods and
  // can't be attributed to a single filing record.
  const year = Number(fiscalYear);
  const qtr = Number(quarter);
  const amount = Number(total);
  if (!clientId || !formCode || !type) return false;
  if (!year || !qtr) return false;
  // The route rejects a non-finite total; don't bother it with one.
  if (!Number.isFinite(amount)) return false;

  try {
    await returnFilingAPI.markAttachmentExported(clientId, formCode, year, qtr, type, amount);
    return true;
  } catch (error) {
    // Never block the actual file download on this — it already succeeded.
    console.error('Failed to record attachment export:', error);
    return false;
  }
};

export default recordAttachmentExport;
